import {
  Acknowledgement,
  AcknowledgementStatus,
} from "components/timesheet/acknowledgement";
import { AddLog, AddLogButton } from "components/timesheet/add-log";
import { HEADER_CONTENT_PORTAL_ID, cn } from "utils";
import { HeaderDescription, HeaderTitle } from "components/timesheet/header";
import {
  TimesheetEntries,
  TimesheetLoading,
  TimesheetRoot,
} from "components/timesheet/timesheet";
import { isValid, parseISO } from "date-fns";
import { useNavigate, useSearchParams } from "react-router-dom";
import HeaderPortal from "components/portal/header-portal";
import AcknowledgmentDialog from "@/modules/timesheet/logs/components/acknowledgement-dialog";
import { Badge } from "ui/components/badge";
import { Button } from "ui";
import { DatePicker } from "components/date-picker";
import EntryCard from "components/timesheet/card/entry";
import { Icon } from "components";
import { LOCK_OPEN } from "icons";
import Lock from "components/timesheet/lock";
import LockCard from "components/timesheet/card/lock";
import { Portal } from "@radix-ui/react-portal";
import TimeSheetLogLayout from "@/modules/timesheet/logs/layout";
import TimesheetLogDayLoader from "@/modules/timesheet/logs/views/day/loader";
import { TimesheetLogProvider } from "components/timesheet/context/log";
import UnlockTimesheetDialog from "@/modules/timesheet/logs/components/unlock/dialog";
import { formatDateForAPI } from "utils/utils";
import { useAcknowledgementMutation } from "components/timesheet/acknowledgement/mutation";
import { useEffect } from "react";
import { usePortal } from "hooks";
import { useState } from "react";
import { eventBus } from "utils/eventBus";

export default function TimesheetLogDay() {
  const [searchParams, setSearchParams] = useSearchParams();

  const day = searchParams.get("date") || formatDateForAPI(new Date());

  const [showUnlockTimesheetDialog, setShowUnlockTimesheetDialog] =
    useState(false);
  const [showAcknowledgeDialog, setShowAcknowledgeDialog] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const parsed = parseISO(day);
    if (!isValid(parsed)) {
      navigate("/timesheet", { replace: true });
    }
  }, [day]);

  const acknowledgementMutation = useAcknowledgementMutation();
  const headerContentPortal = usePortal({
    elementId: HEADER_CONTENT_PORTAL_ID,
  });

  const handleAcknowledgeCreation = async () => {
    await acknowledgementMutation.mutateAsync(day);
    eventBus.emit("refresh", `timesheet-${day}`);

    setShowAcknowledgeDialog(false);
  };

  return (
    <TimeSheetLogLayout>
      <HeaderPortal className="flex gap-3">
        <DatePicker day={day} setSearchParams={setSearchParams} />
      </HeaderPortal>
      <TimesheetLogProvider date={day}>
        <TimesheetLoading>
          <TimesheetLogDayLoader />
        </TimesheetLoading>
        <TimesheetRoot>
          <div className=" lg:px-6 px-4">
            <div className="flex flex-col gap-6">
              <div className="flex justify-between md:items-center md:gap-6 gap-4 md:flex-row flex-col">
                <Portal container={headerContentPortal}>
                  <div>
                    <div className="flex items-center">
                      <HeaderTitle className="text-xl font-semibold " />
                      <Acknowledgement>
                        {({ isAcknowledged, totalLogsInADay }) => (
                          <Badge
                            className={cn(
                              "ml-2",
                              isAcknowledged
                                ? "bg-secondary text-secondary-foreground"
                                : "bg-red-50 text-red-900 border-none"
                            )}
                          >
                            {totalLogsInADay} Hour
                            {totalLogsInADay > 1 ? "s" : ""}
                          </Badge>
                        )}
                      </Acknowledgement>
                      <AcknowledgementStatus className="text-gray-500 size-4.5 ml-2" />
                    </div>
                    <HeaderDescription className="text-sm text-muted-foregroun mt-1" />
                  </div>
                </Portal>
                <HeaderPortal>
                  <div className="flex gap-6 justify-end items-center flex-row-reverse md:flex-row order-2">
                    <Lock>
                      <AddLogButton />
                    </Lock>
                    <Lock show>
                      <Button
                        onClick={() => setShowUnlockTimesheetDialog(true)}
                        variant="outline"
                      >
                        <Icon icon={LOCK_OPEN} /> Unlock This Day
                      </Button>{" "}
                    </Lock>
                  </div>
                </HeaderPortal>
              </div>
            </div>
            <div className={" flex flex-wrap items-stretch gap-4.5 py-1"}>
              <Lock show>
                <LockCard onClick={() => setShowUnlockTimesheetDialog(true)} />
              </Lock>
              <TimesheetEntries>
                {({ entry }) => (
                  <EntryCard key={entry.id} entry={entry} href={entry.id} />
                )}
              </TimesheetEntries>

              <Lock>
                <AddLog />
              </Lock>
              <Acknowledgement
                hideIfEntries={true}
                onAcknowledge={() => setShowAcknowledgeDialog(true)}
              />
            </div>
          </div>
        </TimesheetRoot>
      </TimesheetLogProvider>
      <AcknowledgmentDialog
        open={showAcknowledgeDialog}
        onOpenChange={setShowAcknowledgeDialog}
        onConfirm={handleAcknowledgeCreation}
        isLoading={acknowledgementMutation.isPending}
      />
      <UnlockTimesheetDialog
        open={showUnlockTimesheetDialog}
        onOpenChange={setShowUnlockTimesheetDialog}
        date={day}
      />
    </TimeSheetLogLayout>
  );
}
